<template>
	<div style="background: #f3f4f7">
		<dialogBox :dialogFlag="subFlag" @callFn="subFlag = false" title="">
			<div class="tcsBox">
				<img src="@/assets/img/编组 5.png" alt="" />
				<h2>组卷完成后您将无法修改试卷题目</h2>
				<p>请仔细检查确定无误后提交试卷</p>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn" @click="subFlag = false">继续组卷</div>
						<div class="loadBtn loadBtnQr" @click="subFn">确认完成</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<dialogBox :dialogFlag="subsFlag" @callFn="tcFn" @qrsFn="tcFn" title="您将离开组卷放弃当前试卷">
			<div class="tcBox">
				<div class="tcItem tcItem1">
					<div>
						<img src="@/assets/img/tm.svg" alt="" />
					</div>
					<p>共有：{{ temTestquest.examinationQuestionIdList?.length }}题</p>
				</div>
				<div class="tcItem tcItem2">
					<div>
						<img src="@/assets/img/yz.svg" alt="" />
					</div>
					<p>填充：{{ yzTnum }}题</p>
				</div>
				<div class="tcItem tcItem3">
					<div>
						<img src="@/assets/img/编组.svg" alt="" />
					</div>
					<p>空白：{{ wzTnum }}题</p>
				</div>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn" @click="lkFn">确认离开</div>
						<div class="loadBtn loadBtnQr" @click="tcFn">继续组卷</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<userHeader />
		<fuHeader :txt="a" type="2" height="53px" />
		<crumbs bTxt="试题选择" type="2" :crumFlag="true" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timsBox">
				<div class="timBox">
					<h1>
						<span v-if="!titFlag">{{ temTestquest.title ? temTestquest.title : '高三暑假每日一听 第一套20期' }}</span>
						<el-input class="myInput" @blur="setnFn" @change="setnFn" v-if="titFlag" v-model="titVal"></el-input>
						<i @click="bxFn" class="el-icon-edit"></i>
					</h1>
					<h2>（选择题{{ tmNum }}小题，每题{{ configData.configValue || '' }}分，共{{ tmNum * configData.configValue || '' }}分）</h2>
					<div class="timuCont">
						<div class="timuZj">
							<div class="timuTm">第一节</div>
							<div class="timuTit">
								听下面
								<span>5</span>
								段录音。每段录音后有一个小题，从题中所给的
								<span>A、B、C</span>
								三个选项中选出最佳选项。听完每段录音后，你都有
								<span>10</span>
								秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。
							</div>
							<div class="timuXcont">
								<div class="timuXitems" v-for="(item, index) in this.temTestquest.examinationQuestionIdList.slice(0, 5)" :key="index">
									<div class="timuTcont">
										<div v-for="(items, indexs) in item.stdec.yydSmallQuestionList" :key="indexs">
											<h2>
												<div class="khao">()</div>
												{{ item?.listTh[indexs] }}、{{ items.title }}
											</h2>
											<p v-for="(a, b) in items.yydSmallQuestionOptionList" :key="b">{{ a.number }} 、{{ a.content }}</p>
											<div class="timuTcontBtn" @click="stBtn(item)">
												<img src="@/assets/img/编组 (7).png" alt="" />
												<span>替换试题</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="timuZj">
							<div class="timuTm">第二节</div>
							<div class="timuTit">
								听下面
								<span>5</span>
								段录音。每段录音后有几个小题，从题中所给的
								<span>A、B、C</span>
								三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题
								<span>5</span>
								秒钟；听完后，每小题都有
								<span>5</span>
								秒钟的作答时间。每段录音播放两遍。
							</div>
							<div class="timuXcont">
								<div class="timuXitems" v-for="(item, index) in this.temTestquest.examinationQuestionIdList.slice(5)" :key="index">
									<div class="timuP">听第{{ 6 + index }}段录音，回答第{{ item?.listTh.join(',') }}题。</div>
									<div class="timuTcont">
										<div v-for="(items, indexs) in item.stdec.yydSmallQuestionList" :key="indexs">
											<h2>
												<div class="khao">()</div>
												{{ item?.listTh[indexs] }}、{{ items.title }}
											</h2>
											<p v-for="(a, b) in items.yydSmallQuestionOptionList" :key="b">{{ a.number }} 、{{ a.content }}</p>
											<div class="timuTcontBtn" @click="stBtn(item)">
												<img src="@/assets/img/编组 (7).png" alt="" />
												<span>替换试题</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="regFot">
								<div class="regBtn" @click="qxBtn">取消</div>
								<div class="regBtn active" @click="subFlag = true">确定组卷</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import crumbs from '@/components/hearder/crumbs';
import fuHeader from '@/components/hearder/fuHeader';
import dialogBox from '@/components/pubComponents/dialogBox';
import { mapState } from 'vuex';

export default {
	name: 'tihuanKt',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4电影
			strName: '',
			titVal: '',
			titFlag: false,
			txt: '',
			configData: {},
			yzTnum: 0,
			wzTnum: 0,
			subFlag: false,
			subsFlag: false,
			a: ['试题选择'],
			nextName: '',
			nextQuery: '',
			nextParams: ''
		};
	},
	components: {
		userHeader,
		fuHeader,
		dialogBox,
		foot,
		crumbs
	},
	computed: {
		...mapState(['temTestquest']),
		tmNum() {
			return this.temTestquest.examinationQuestionIdList[this.temTestquest.examinationQuestionIdList.length - 1]?.listTh[
				this.temTestquest.examinationQuestionIdList[this.temTestquest.examinationQuestionIdList.length - 1]?.listTh.length - 1
			];
		}
	},
	methods: {
		subFn() {
			console.log(this.temTestquest, 7778);
			let flag = false;
			let examinationQuestionIdList = this.temTestquest.examinationQuestionIdList.map((item) => {
				if (item.stdec.examinationQuestionId) {
					return item.stdec.examinationQuestionId;
				} else {
					flag = true;
					return '';
				}
			});
			if (flag) {
				this.$message({
					type: 'warning',
					message: '请填写完成题目后，在提交'
				});
				return;
			}
			let set = this.$loading(this.$pre);
			console.log(examinationQuestionIdList, 8887777);
			this.$http
				.post('api/app/yydGroupQuestionExam', {
					examinationQuestionIdList,
					templateId: this.temTestquest.templateId,
					title: this.temTestquest.title ? this.temTestquest.title : '高三暑假每日一听 第一套20期'
				})
				.then((res) => {
					set.close();
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: '创建成功'
						});
						this.subFlag = false;
						this.$router.push({
							path: 'mySj'
						});
					}
				});
		},
		qxBtn() {
			this.$store.commit('setTemTest', {});
			this.$router.push({
				path: 'zujuan'
			});
		},
		lzFn() {
			this.decFlag = true;
		},
		tkFn() {
			this.decFlag = false;
		},
		setnFn() {
			console.log(this.titVal, 111);
			this.$store.commit('setTemName', this.titVal);
			this.titFlag = false;
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
		},
		lkFn() {
			this.subsFlag = false;
			this.$router.push({
				path: this.nextName,
				query: {
					...this.nextQuery,
					tys: 777
				},
				params: {
					...this.nextParams
				}
			});
			console.log(this.nextName, '离开了');
		},
		tcFn() {
			this.subsFlag = false;
		},
		pxFn(type) {
			this.pxFlag[type] == 2 ? (this.pxFlag[type] = 0) : this.pxFlag[type]++;
		},
		daBtn(s, index, b, val) {
			// item = val
			this.$set(this.daJh[s].children[index].tms, b, val);
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str
				}
			});
		},
		bxFn() {
			this.titFlag = !this.titFlag;
			this.titVal = this.temTestquest.title;
		},
		stBtn(item) {
			this.$router.push({
				path: 'zujuan',
				query: {
					type: 2,
					qrType: 2, // 是否是确认试卷
					stStand: JSON.stringify(item)
				}
			});
		},
		init() {
			console.log(this.temTestquest, 9999);
			if (this.temTestquest.examinationQuestionIdList) {
				let str = '';
				str = this.temTestquest.examinationQuestionIdList
					.map((item) => {
						return item.type;
					})
					.join(',');
				if (str.includes('D') && str.includes('Q')) {
					this.strName = '对话或独白';
				}
				if (str.includes('Q') && !str.includes('D')) {
					this.strName = '对话';
				}
				if (str.includes('D') && !str.includes('Q')) {
					this.strName = '独白';
				}
			}
			this.fullscreenLoading = true;
			this.$http.get(`api/system/dict/data/config/sys.question.score`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.configData = res.data;
				}
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		console.log(to, from, 222);
		if ((to.path == '/zujuan' && to.query.stStand) || to.path == '/mySj' || to.path == '/tihuanKt' || to.query.tys == '777') {
			next();
		} else {
			this.nextQuery = to.query;
			this.nextParams = to.params;
			this.nextName = to.path;
			this.subsFlag = true;
		}
	},
	activated() {
		const { tjStatus } = this.$route.query;
		if (tjStatus) {
			let num = 0;
			this.temTestquest.examinationQuestionIdList.forEach((item) => {
				if (item.stdec.examinationQuestionId) {
					num++;
				}
			});
			this.yzTnum = num;
			this.wzTnum = this.temTestquest.examinationQuestionIdList?.length - num;
		}
	},
	mounted() {
		const { type, txt } = this.$route.query;
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.timsBox {
	width: 1200px;
	margin: 0 auto 10px;
}
.timBox {
	background: #ffffff;
	border-radius: 4px;
	padding: 38px 15px 42px;
	position: relative;
	h1 {
		font-size: 28px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 25px;
		text-align: center;
		height: 40px;
		i {
			color: #1d7b3a;
			cursor: pointer;
			margin-left: 8px;
		}
		.myInput {
			width: 380px;
			text-align: center;
			font-size: 28px;
			color: #000000;
			font-weight: bold;
		}
	}
	h2 {
		font-size: 18px;
		text-align: center;
		color: #000000;
		padding-bottom: 34px;
		margin-bottom: 27px;
		border-bottom: 1px solid #f8f8f8;
	}
	.timuCont {
		padding: 0 50px;
		.timuZj {
			margin-bottom: 40px;
			&:last-of-type {
				margin-bottom: 0;
			}
			.timuTm {
				margin-bottom: 13px;
				color: #000000;
				font-size: 18px;
				font-weight: bold;
				text-indent: 2em;
			}
			.timuTit {
				color: #3d3d3d;
				text-indent: 2em;
				line-height: 1.7;
				margin-bottom: 36px;
				span {
					font-weight: bold;
				}
			}
			.timuP {
				font-weight: bold;
				margin-bottom: 13px;
				color: #000000;
				font-size: 16px;
				text-indent: 2em;
			}
			.timuXcont {
				.timuXitem {
					height: 60px;
					background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
					border-radius: 6px;
					border: 1px solid #e0e0e0;
					display: flex;
					align-items: center;
					cursor: pointer;
					padding-left: 14px;
					font-size: 14px;
					color: #000000;
					margin-bottom: 10px;
					position: relative;
					p {
						position: absolute;
						color: #8b8b8b;
						font-size: 12px;
						left: 50%;
						transform: translateX(-50%);
						i {
							font-weight: bold;
							margin-right: 2px;
						}
					}
				}
				.timuXactive {
					p {
						color: #1d7b3a !important;
					}
				}
				.timuTcont {
					padding: 20px 0 14px 41px;
					margin: 30px 0 18px;
					border-radius: 15px;
					text-align: left;
					position: relative;
					&:hover {
						background: #e8f1eb;
					}
					.timuTcontBtn {
						position: absolute;
						cursor: pointer;
						right: 16px;
						bottom: 17px;
						width: 105px;
						height: 36px;
						background: #1d7b3a;
						border-radius: 7px;
						border: 1px solid #14652d;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 14px;
						color: #ffffff;
						img {
							width: 15px;
							height: 12px;
							margin-right: 6px;
						}
					}
					h2 {
						display: flex;
						margin-bottom: 12px;
						font-weight: bold;
						padding: 0;
						border: 0;
						border-radius: 15px;
						.khao {
							width: 102px;
							letter-spacing: 60px;
						}
					}
					> div {
						margin-bottom: 20px;
					}
					p {
						padding-left: 102px;
						line-height: 2;
					}
				}
			}
		}
	}
	.timBtns {
		position: absolute;
		left: -75px;
		top: 0;
		.timBtn {
			width: 65px;
			height: 65px;
			background: #1d7b3a;
			border-radius: 6px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			color: #fff;
			font-size: 14px;
			cursor: pointer;
			margin-bottom: 15px;
			img {
				width: 18px;
				height: 21px;
				margin-bottom: 5px;
			}
		}
		.timBtn1 {
			background: #ffffff;
			color: #82807c;
			img {
				width: 21px;
				height: 21px;
				margin-bottom: 5px;
			}
		}
		.timBtn2 {
			background: #d33931;
			color: #fff;
		}
	}
}
.regFot {
	display: flex;
	justify-content: center;
	margin-top: 50px;

	.regBtn {
		width: 88px;
		height: 40px;
		margin-right: 25px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;

		&:last-of-type {
			margin-right: 0;
		}
	}

	.active {
		background: #1d7b3a;
		color: #ffffff;
		border: 1px solid #1d7b3a;
	}
}
.tcsBox {
	margin: 0 0 40px;
	text-align: center;
	img {
		width: 86px;
		margin-bottom: 34px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9c9c9c;
	}
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}
.tcBox {
	margin: 6px 0 40px;
	display: flex;
	justify-content: space-between;
	.tcItem {
		width: 133px;
		height: 93px;
		background: #f8f9fd;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		div {
			width: 34px;
			height: 34px;
			margin-bottom: 7px;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}
	.tcItem1 {
		div {
			img {
				width: 30px;
				height: 30px;
			}
		}
		color: #000000;
	}
	.tcItem2 {
		color: #10c257;
	}
	.tcItem3 {
		color: #ff3030;
		div {
			img {
				width: 30px;
				height: 30px;
			}
		}
	}
}
</style>
